import React, { useState, useCallback, useMemo } from 'react'
import styled from 'styled-components'

import SelectChainModal from './SelectChainModal'
import Item from './Item'
import AnotherDimension from '~shared/AnotherDimension'

const UnstyledChainSelector = ({
    chains,
    selectedChainId,
    onChainSelected: onChainSelectedProp,
    disabled,
}) => {
    const [open, setOpenState] = useState(false)

    const onChainSelected = useCallback(
        (chainId) => {
            if (onChainSelectedProp && typeof onChainSelectedProp === 'function') {
                onChainSelectedProp(chainId)
            }
        },
        [onChainSelectedProp],
    )

    const activeChain = useMemo(
        () => chains.find(({ id }) => id === selectedChainId),
        [chains, selectedChainId],
    )

    const setOpen = useCallback(
        (isOpen) => {
            if (disabled) {
                return
            }

            setOpenState(isOpen)
        },
        [disabled],
    )

    return (
        <>
            {!!activeChain && (
                <Item
                    chain={activeChain}
                    onClick={() => setOpen(true)}
                    isDropdown
                    disabled={disabled}
                />
            )}
            <AnotherDimension>
                <SelectChainModal
                    close={() => setOpen(false)}
                    shown={open}
                    items={chains}
                    selectedChain={selectedChainId}
                    onChainSelected={onChainSelected}
                />
            </AnotherDimension>
        </>
    )
}

const ChainSelector = styled(UnstyledChainSelector)``

export default ChainSelector
